<script setup lang="ts">
import type { VPillProps } from "./VPill.types";
import { computed } from "vue";
import { pillCva, pillOutlineCva } from "./VPill.cva";

defineOptions({
  name: "VPill",
});

const {
  size = "md",
  disabled = false,
  appearance = "filled",
} = defineProps<VPillProps>();

const emit = defineEmits<{
  click: [event: MouseEvent]
}>();

defineSlots<{
  default?: () => unknown
}>();

const model = defineModel<boolean>({ default: false });

const classes = computed(() => ({
  pill: appearance === "outline"
    ? pillOutlineCva({ active: model.value, disabled })
    : pillCva({ size, active: model.value, disabled }),
}));

function onClick(event: MouseEvent) {
  if (disabled) {
    return;
  }

  emit("click", event);
  model.value = !model.value;
}
</script>

<template>
  <button
    type="button"
    :class="classes.pill"
    :disabled="disabled"
    :aria-pressed="model"
    data-test="vpill"
    @click="onClick"
  >
    <slot />
  </button>
</template>
